'use client'

import { usePathname, useSearchParams } from 'next/navigation'
import { useEffect, useRef } from 'react'
import { initMatomo, isMatomoEnabled, sanitizeTrackedPath, trackPageView } from '~/lib/matomo'

function MatomoTracker() {
  const pathname = usePathname()
  const searchParams = useSearchParams()
  const lastTrackedPathRef = useRef<string | null>(null)

  const isTestMode = searchParams.get('test') === 'true'

  useEffect(() => {
    if (!isMatomoEnabled() || isTestMode) return
    initMatomo()
  }, [isTestMode])

  useEffect(() => {
    if (!pathname) return
    if (!isMatomoEnabled() || isTestMode) return

    const sanitizedPath = sanitizeTrackedPath(pathname)
    if (lastTrackedPathRef.current === sanitizedPath) return

    trackPageView(sanitizedPath)
    lastTrackedPathRef.current = sanitizedPath
  }, [pathname, isTestMode])

  return null
}

export default MatomoTracker
